import React, { useEffect, useState } from 'react';
import { Badge, Button, Col, Popover, Row, Typography } from 'antd';
import { Header } from 'antd/es/layout/layout';
import BrandLogo from '../assets/images/logo-light.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';
import { themecolor } from '../config.js';
import { CalendarCheck, FileOutput, LifeBuoy, Lock, MessageSquare, Settings, UserCircle2, Wallet } from 'lucide-react';
import arrow from '../../src/assets/images/back_arrow.svg';
import usecustomStyles from '../Common/customStyles';
import { MenuUnfoldOutlined } from '@ant-design/icons';
import locationLogo from '../../src/assets/images/location_logo.png';
import settingsIcon from '../../src/assets/images/setting_icon.png';
import notificationIcon from '../../src/assets/images/notification_icon_dark.png';
import { useDispatch, useSelector } from 'react-redux';
import { businessInfo } from '../slices/businessInfo/thunk.js';
import { getNotification, getNotificationAll } from '../slices/notificationAll/thunk.js';
import Log from '../Services/Log.jsx';
import { getDashboard } from '../slices/dashboard/thunk.js';
import { ShimmerTitle } from 'react-shimmer-effects';
import Avatar from '../pages/Components/Avatar/Avatar.jsx';

const customStyles = usecustomStyles();

const { Text } = Typography;
const StyleHeader = styled(Header)`
  padding-inline: 24px;
  position: fixed;
  left: ${({ theme }) => theme.direction === 'rtl' ? '0' : `${themecolor.components.Menu.verticalSidebarWidth}px`};
  right: ${({ theme }) => (theme.direction === 'rtl' ? `${themecolor.components.Menu.verticalSidebarWidth}px` : '0')};
  top: 0;
  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.token.colorBorder};
  z-index: 999;
  background: ${({ theme }) => theme.token.colorBgContainer};
  
  @media screen and (max-width: 768px) {
    /* Apply the responsive style without considering RTL or LTR */
    left: 0;
    right: 0;
  }
`;

const HeaderContainer = styled.ul`
  font-size: 15px;
  padding-inline: 0;
  display: flex;
  gap: 10px;
  margin: 0;
  justify-content: end;

  .ant-avatar {
    background-color: transparent;
    transition: all 0.5s ease;
    &:hover {
        background-color: ${({ theme }) => theme.token.colorBorder};
    }
  }
`;

const StyleFlagDropdown = styled.div`
  min-width:145px;

  ul {
    li {
        padding: 5px 0;
        a {
            transition: all 0.5s ease;
            &:hover {
                color: ${customStyles.colorPrimary};
            }
        }
    }
  }
`;

const profileContentPopover = (
    <StyleFlagDropdown>
        <ul style={{ padding: "6px", listStyleType: "none" }} className='ant-pl-0 ant-mb-0'>
            <li>
                <Text type="secondary" style={{ fontSize: "13px" }}>Welcome Admin!</Text>
            </li>
            <li>
                <Link to="/user-profile">
                    <Text type="secondary"><UserCircle2 className='ant-mr-1' size={16} /></Text><Text> Profile</Text>
                </Link>
            </li>
            <li>
                <Link to="/app-chat">
                    <Text type="secondary"> <MessageSquare className='ant-mr-1' size={16} /></Text><Text> Messages</Text>
                </Link>
            </li>
            <li>
                <Link to="/#">
                    <Text type="secondary"> <CalendarCheck className='ant-mr-1' size={16} /></Text><Text> Taskboard</Text>
                </Link>
            </li>
            <li style={{ borderBottom: "1px solid", borderBottomColor: "#eff2f7" }}>
                <Link to="/#">
                    <Text type="secondary"> <LifeBuoy className='ant-mr-1' size={16} /></Text><Text> Help</Text>
                </Link>
            </li>
            <li>
                <Link to="/#">
                    <Text type="secondary"> <Wallet className='ant-mr-1' size={16} /></Text><Text> Balance:<b>$8451.36</b></Text>
                </Link>
            </li>
            <li>
                <Link to="/#">
                    <Text type="secondary"> <Settings className='ant-mr-1' size={16} /></Text><Text> Settings</Text>  <Badge count={"New"} style={{ marginLeft: customStyles.marginSM, backgroundColor: customStyles.colorSuccessBg, color: customStyles.colorSuccess }}></Badge>
                </Link>
            </li>
            <li>
                <Link to="/auth-lockscreen">
                    <Text type="secondary"> <Lock className='ant-mr-1' size={16} /></Text><Text> Lock Screen</Text>
                </Link>
            </li>
            <li>
                <Link to="/logout">
                    <Text type="secondary"> <FileOutput className='ant-mr-1' size={16} /></Text><Text> Logout</Text>
                </Link>
            </li>
        </ul>
    </StyleFlagDropdown>
);

const HeaderLayout = ({ darkMode, handleToggleMode }) => {
    const [isClick, setIsClick] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const navigate = useNavigate();
    const location = useLocation();
    const [visiblePath, setVisiblePath] = useState('');
    const notificationData = useSelector((state) => state.NotificationAll.notificationAll);
    const [notificationCount , setNotificationCount] = useState(0);
    const dispatch = useDispatch();
    const [showShimmer , setShowShimmer] = useState(false);

    useEffect(() => {
        dispatch(getNotificationAll({ limit: 101, page: 1 }));
        setIsClick(false);
        updateWindowDimensions();
        window.addEventListener('resize', updateWindowDimensions);

        return () => {
            window.removeEventListener('resize', updateWindowDimensions);
        };

        // checking the user verification 

    }, []);

    useEffect(()=>{
        dispatch(businessInfo());

    },[location])

    useEffect(()=>{
        dispatch(getDashboard());
    },[location.pathname])

    const dashboardData = useSelector((state)=>state.Dashboard);

    useEffect(()=>{
        if(dashboardData){
          if(dashboardData?.data?.profile_verified_admin === true){
            localStorage.setItem('isVerified', true);
          }else{
            localStorage.setItem('isVerified', false);
          }  
        }
    
      },[dashboardData , dispatch ])
    
    const mobBusinessInfo = useSelector((state) => state.BusinessInfoReducer)

    useEffect(() => {
        pathUpdate(location.pathname);
    }, [location.pathname]);

    const updateWindowDimensions = () => {
        setWindowWidth(window.innerWidth);
    };

    const handleToggleButton = () => {
        setIsClick(prevIsClick => !prevIsClick);
        const sidebarLayout = document.getElementById('sidebar-layout');
        sidebarLayout.style.display = isClick ? 'none' : 'block';
    };

    useEffect(() => {
        const sidebarLayout = document.getElementById('sidebar-layout');
        if (sidebarLayout) {
            if (windowWidth < 768) {
                sidebarLayout.style.display = 'none';
            } else {
                sidebarLayout.style.display = 'block';
            }
        }
    }, [windowWidth]);

    const pathUpdate = (pathname) => {
        const lastWord = pathname.split('/').pop();
        switch (lastWord) {
            case 'new-ads':
                setVisiblePath('Manage Ad');
                break;
            default:
                setVisiblePath(pathname.slice(1));
                break;
        }
    };
    let split = visiblePath.split('/');
    useEffect(()=>{
        if(notificationData?.length > 0){
           setNotificationCount(notificationData.filter(notification => !notification.is_read).length)
        }
    },[notificationData])

    useEffect(() => {
        // Set a timeout to hide the shimmer after 400 seconds (400,000 milliseconds)
        const timer = setTimeout(() => {
          setShowShimmer(false);
        }, 400000);
    
        // Clear the timeout if the component is unmounted
        return () => clearTimeout(timer);
      }, []);


    useEffect(()=>{
       console.log('mobBusinessInfo?.businessInfo' , mobBusinessInfo?.businessInfo)
    },[mobBusinessInfo?.businessInfo])

    // user verification '

    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //       setShowShimmer(false);
    //     }, 3000);
    
    //     return () => clearTimeout(timer);
    //   }, []);




    return (
        <React.Fragment>
            <StyleHeader id="antHeaderMain" className='header' >
                <Row align="middle" className='nav_wrapper' gutter={[16, 24]}>
                    {windowWidth < 768 && (
                        <Col>
                            <img src={BrandLogo} height={24} style={{ display: 'none' }} alt='' />
                            <Button type='primary' className='collapse_btn' onClick={handleToggleButton}><MenuUnfoldOutlined /></Button>
                        </Col>
                    )}
                    <div className='main_logo_wrap'>
                        {location.pathname === '/dashboard' ? (
                            <div className='location'>
                                {
                                    (mobBusinessInfo?.businessInfo?.business_logo?.original || mobBusinessInfo?.businessInfo?.old_business_logo?.original) ? (
                                        <span className='logo sm red_shadow'>
                                        <img src={mobBusinessInfo?.businessInfo?.business_logo?.original ? mobBusinessInfo?.businessInfo?.business_logo?.original : mobBusinessInfo?.businessInfo?.old_business_logo?.original} alt=""/>
                                    </span>
                                    ):
                                    <Avatar>{mobBusinessInfo?.businessInfo?.business_name?.[0] || mobBusinessInfo?.businessInfo?.old_business_name?.[0] }</Avatar>
                                }
                              
                                <div className='cnt'>
                                    <span style={{fontWeight: "600" }} className='text_md2 text_capitalize'>{!mobBusinessInfo?.businessInfo?.business_name ? mobBusinessInfo?.businessInfo?.old_business_name : mobBusinessInfo?.businessInfo?.business_name}</span>
                                    <span className='app__category'>{mobBusinessInfo?.businessInfo?.business_category}</span>
                                    <span className="app__location">{mobBusinessInfo?.businessInfo?.business_address ? mobBusinessInfo?.businessInfo?.business_address : mobBusinessInfo?.businessInfo?.old_business_address}</span>
                                </div>
                            </div>
                        ) : (
                            <div className='back_cnt' style={{ display: "flex", alignItems: "center" }}>
                                <Button
                                    className='default_remove back_button'
                                    style={{ display: "flex", padding: 0, marginLeft: "17px"}}
                                    onClick={() => navigate(-1)}
                                >
                                    <img src={arrow} alt='' className='img_full contain' />
                                </Button>
                               
                                <p style={{ marginBottom: 0, textTransform: "capitalize", transition: '.4s', fontSize: 'calc(15px + .5vw )' , lineHeight: 1.5 }}>
                               {
                                showShimmer && (
                                    <div className='header_title_shimmer'>
                                    <ShimmerTitle line={1} gap={10} />
                                </div>
                                )
                               }
                                {split[0] == 'live-ads' ? (
                                        <div className='title_support'>
                                            <span>My Ads</span>
                                            { split[1] &&  <span className='md'> <span>Ad ID :</span>&nbsp;{split[1]}</span>}
                                        </div>
                                    ) : (
                                        visiblePath.replace('-' , ' ')
                                    )}
                                </p>
                            </div>
                        )}
                    </div>
                    <Col className='ant-ml-auto'>
                        <HeaderContainer className='ant-topbar-head list-unstyled'>
                            <li>
                                <Link to='/notifications' className='notification_link'>
                                    <img src={notificationIcon} alt='notification' />
                                    {
                                        (location.pathname !== '/notifications' && notificationCount !== 0 ) &&  <span className='notification_count'>{notificationCount > 99 ? '99+' : notificationCount}</span>
                                    }
                                   
                                </Link>
                            </li>
                            <li>
                                <Link to='/settings'>
                                    <img src={settingsIcon} alt='settings' />
                                </Link>
                            </li>
                        </HeaderContainer>
                    </Col>
                </Row>
                
            </StyleHeader>
        </React.Fragment>
    );
};

export default HeaderLayout;
